export const ValueMap = {
  PCList: {
    "Ball": 'Ball',
    "Swing & Miss": 'Strk-S',
    "Called Strike": 'Strk-C', 
    "Foul": 'Foul',
    "In Play": 'In-Play',
  },
  HTList: {
    "Ground": 'GROUND', 
    "Line": 'LINE',
    "Fly": 'FLYB',
    "Pop-up": 'POPB',
  },
  PRList: { 
    "Single": '1B',
    "Double": '2B',
    "Triple": '3B',
    "Homerun": 'HR',
    "Fly Out": 'FO',
    "Ground Out": 'GO',
    "Double Play": 'DP',
    "Triple Play": 'TP',
    "Error": 'E',
    "Sac-Fly": 'SF',
    "Sac-Bunt": 'SH',
    "Outs": 'OUT',
  },
  OList: {
    "0 out": 0,
    "1 out": 1,
    "2 out": 2
  },
  OBList: {
    "RISP": 0,
    1: 1,
    2: 2,
    3: 4,
  },
  HardTList: {
    "HARD": 'HARD',
    "MED": 'MED',
    "SOFT": 'SOFT'
  },
  BarrelList: {
    "Barrels": "Barrels",
    "Solid Contact": "Solid_Contact",
    "Flares & Bumers": "Flares_Bumers",
    "Topped": "Topped",
    "Hit Under": "Hit_Under",
    "Weak Contact": "Weak_Contact"
  },
  ZPointList: {
    "內角球": 'Right',
    "中間球": 'H_Med',
    "外角球": 'Left',
    "高球": 'High',
    "中球": 'V_Med',
    "低球": 'Low'
  },
  TagPList: {
    "Fastball": 'FB',
    "Sinker": 'FT',
    "SFF": 'SFF',
    "Slider": 'SL',
    "Curve": 'CB',
    "Cutter": 'CT',
    "Change-up": 'CH',
    "Splitter": 'SP',
    "Slow Curve": 'SC',
    "Knuckle": 'KN',
    "Others": 'OT'
  }
}

export const TaggedPitchTypeLabelMap = {
  "all": "全部",
  "FB": "直球",
  "FT": "伸卡",
  "CT": "卡特",
  "SL": "滑球",
  "CB": "曲球",
  "SC": "慢速曲球",
  "CH": "變速球",
  "SP": "指叉球",
  "SFF": "快速指叉",
  "OT": "其他",
  "UN": "未知",
  "KN": "蝴蝶球",
  "?": "?",
  "": "N/A",
  null: "IBB"
}